import PersonalSection from './PersonalSection';
import SettingsSection from './SettingsSection';
import SubscriptionsSection from './SubscriptionsSection';
import type { ProfileSection } from './types';

interface ProfileSectionContentProps {
	activeSection: ProfileSection;
}

export default function ProfileSectionContent({ activeSection }: ProfileSectionContentProps) {
	if (activeSection === 'personal') {
		return <PersonalSection />;
	}

	if (activeSection === 'settings') {
		return <SettingsSection />;
	}

	return <SubscriptionsSection />;
}